export default __webpack_public_path__ + "static/media/iPhone-1.fba26d95.png";